import { Component } from '@angular/core'
import { ThemeService } from '../../../services/theme/theme.service'
import { FormsModule } from '@angular/forms'
import { ToggleButtonModule } from 'primeng/togglebutton'

@Component({
  selector: 'app-dark-mode-switch',
  imports: [FormsModule, ToggleButtonModule],
  templateUrl: './dark-mode-switch.component.html',
  styleUrl: './dark-mode-switch.component.scss',
})
export class DarkModeSwitchComponent {
  checked: boolean = false

  constructor(private themeService: ThemeService) {
    this.checked = this.themeService.isDark()
  }

  switchTheme() {
    this.themeService.switchTheme()
  }
}
